export default {
  setEquipments(state, models) {
    state.equipments = models
  },
}
